<template>
  <label
    class="button-toggle"
    :class="[
      checkboxClass,
      {
        'left-label': leftLabel,
        disabled,
      },
    ]"
  >
    <span
      v-if="label && leftLabel"
      class="label left text-medium"
    >
      {{ label }}
    </span>
    <input
      v-model="checkedValues"
      type="checkbox"
      :name="name"
      :value="value"
      :disabled="disabled"
    />
    <UilSquare
      v-if="!isValueChecked"
      class="icon"
      size="24"
    />
    <UisMinusSquareFull
      v-else-if="mix"
      class="icon mix"
      size="24"
    />
    <UisCheckSquare
      v-else
      class="icon"
      size="24"
    />

    <span
      v-if="label && !leftLabel"
      class="label right text-medium"
    >
      {{ label }}
    </span>
  </label>
</template>

<script>
import { defineComponent } from "vue";
import { UilSquare } from "@lde/vue-unicons";
import { UisCheckSquare, UisMinusSquareFull } from "@lde/vue-unicons-solid";

/**
 * Affiche une checkbox.
 */
export default defineComponent({
  name: "ButtonCheckbox",
  components: {
    UilSquare,
    UisCheckSquare,
    UisMinusSquareFull,
  },
  props: {
    /**
     * Checkboxe(s) sélectionnée(s).
     */
    modelValue: {
      type: [Array, Boolean],
      default: null,
    },
    /**
     * Valeur de la checkbox.
     */
    value: {
      type: [String, Number],
      default: null,
    },
    /**
     * Texte dans le bouton.
     */
    label: {
      type: String,
      default: "",
    },
    /**
     * Affiche le label à gauche de la checkbox.
     */
    leftLabel: {
      type: Boolean,
      default: false,
    },
    /**
     * Nom du groupe des inputs.
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * Affiche un tiret au lieu d'un symbole de validation.
     */
    mix: {
      type: Boolean,
      default: false,
    },
    /**
     * Change la couleur en blanc de la checkbox et du label associé.
     */
    white: {
      type: Boolean,
      default: false,
    },
    /**
     * Désactive la checkbox.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    /**
     * Déclenché au changement d'état du bouton.
     * @param {Boolean} - Si la checkbox est cochée ou pas.
     */
    "update:modelValue",
  ],
  computed: {
    isValueChecked() {
      return ((this.modelValue instanceof Array && this.modelValue.indexOf(this.value) > -1)
        || (!(this.modelValue instanceof Array) && this.modelValue));
    },
    checkboxClass() {
      const customClasses = [];

      if ((this.modelValue instanceof Array && this.modelValue.indexOf(this.value) > -1)
        || (!(this.modelValue instanceof Array) && this.modelValue)) {
        customClasses.push("checked");
      }
      if (this.white) {
        customClasses.push("white");
      } else customClasses.push("empty");

      return customClasses;
    },
    checkedValues: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
});
</script>

<style lang="scss">
@use "../../assets/styles/components/buttons/button_toggle.scss";
</style>
